import useFeatureFlagsQuery from '../queries/useFeatureFlagsQuery.hook';

export default function useFeatureFlag(flagName) {
  const { data: flags } = useFeatureFlagsQuery();
  return flags?.[flagName] ?? false;
}
